import Token from '@/utils/Token';

export default {
    parse(data) {
        ['valor'].forEach(item => {
            if(data[item]) {
                data[item] = parseFloat(data[item]);
            }
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cotacao/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cotacao/list${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/cotacao/download${params}`, headers);
    },
    listContrato(contrato_id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cotacao/listContrato/${contrato_id}${params}`, Token.getHeader());
    },
    create(params) {
        return axios.post(`/api/cotacao`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/cotacao/${id}`, params, Token.getHeader());
    },
    aprovacao(id,params) {
        return axios.post(`/api/cotacao/aprovacao/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/cotacao/${id}`, Token.getHeader());
    },
}
